<template>
  <div>
    <a-modal v-model:visible="visible" title="小医微测详情" @ok="handleOk" okText="新建" cancelText="关闭" :afterClose="closeModal" width="50vw" :okButtonProps="{ style: { display: 'none' } }">
      <div class="detail-container">
        <div class="detail-row">
          <label>时间：</label>
          <span>{{ formState?.createdDate }}</span>
        </div>
        <div class="detail-row">
          <label>姓名：</label>
          <span>{{ formState?.customer?.name }}</span>
        </div>
        <div class="detail-row">
          <label>电话：</label>
          <span>{{ formState?.customer?.mobile }}</span>
        </div>
        <div class="detail-row">
          <label>结果：</label>
          <span>{{ formState?.tcmResult }}</span>
        </div>

        <!-- 通用附加内容区块 -->
        <div class="detail-section">
          <div class="section-header">相关症候</div>
          <div class="section-body">
            <div v-for="(item, index) in formState.syndromeList" :key="index" class="section-item">
              {{ item }}
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { Detail } from "/src/api/microTest.js";

export default {
  components: {},
  data() {
    return {
      visible: this.modelValue,
      formState: {},
    };
  },
  emits: ['update:modelValue'],
  props: {
    record: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    async detail() {
      if (!this.record?.id) return;
      let res = await Detail({ id: this.record.id });
      this.formState = res.data;
    },
    closeModal() {
      this.$emit('update:modelValue', false);
    },
    handleOk() {
      // 按钮已隐藏
    },
  },
  watch: {
    record(val) {
      this.detail();
    },
    modelValue(val) {
      this.visible = val;
    },
  },
};
</script>

<style scoped>
</style>